var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"rules":_vm.rules,"hide-details":"","items":_vm.$store.state.clients.root.data,"item-text":"name","item-value":"id","label":"Cliente *","value":parseInt(_vm.$store.state.openProduct.root.data.company_id)},on:{"input":function($event){return _vm.handleSelect($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }